import { css } from 'styled-components';
import { themeUtils as tu } from '@zen-common/components-base';

export const borderBottomContainerCss = css`
  border-bottom: ${tu.borderWidths(1)} solid ${tu.color('borderDark')};
  padding: ${tu.space('md')} 0;
`;
